import { render, staticRenderFns } from "./TrackMyOrder.vue?vue&type=template&id=497b2e34&scoped=true&"
import script from "./TrackMyOrder.vue?vue&type=script&lang=js&"
export * from "./TrackMyOrder.vue?vue&type=script&lang=js&"
import style0 from "./TrackMyOrder.vue?vue&type=style&index=0&id=497b2e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b2e34",
  null
  
)

export default component.exports